import * as moment from 'moment-business-days';

import {
  OnInit,
  Component,
} from 'ng-metadata/core';

@Component({
  selector: 'gw-passport-departure-date',
  template: `
    <time datetime="{{ ::$ctrl.date | amDateFormat }}">
      {{ ::$ctrl.date | amDateFormat: 'MM/DD/YYYY' }}
    </time>
  `,
})
export class PassportDepartureDateComponent implements OnInit {
  public date = moment().businessAdd(5);

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/common/departure-date/departure-date.component.ts